<div class="page-container gap-3">
  <app-page-header
    title="People"
    description="Build contacts and groups to share forms with the right people.">
    <lib-signal-button
      iconSrc="assets/icons/plus.svg"
      [fullWidth]="false"
      (clicked)="onCreate()">
      {{ createLabel() }}
    </lib-signal-button>
  </app-page-header>

  <nav
    class="flex shrink-0 gap-1 border-b border-neutral-200"
    aria-label="People sections">
    @for (tab of tabs; track tab.link) {
      <a
        [routerLink]="tab.link"
        routerLinkActive="!border-primary-600 text-primary-700 font-semibold"
        class="inline-flex -mb-px items-center gap-2 border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-neutral-600 transition hover:text-neutral-900">
        <app-svg-icon [src]="tab.iconSrc" [size]="18" />
        {{ tab.label }}
      </a>
    }
  </nav>

  <div class="page-fill">
    <router-outlet />
  </div>
</div>
